const resolution = {width: 1920, height: 1080};
const packFolder = "desktop_horizontal/";
const pathFolder = "desktop_horizontal/";

export const configGame_desktop_horizontal = {
    packFolder: packFolder,
    pathFolder: pathFolder,
    type: "DesktopHorizontal",

    Screen: {
        resolution: resolution,
        screen_ratio: resolution.width / resolution.height,
        loadscreen: {
            image: {name: "res/" + pathFolder + "loadscreen.jpg", rus: true},
            loadbar:{
                position: {x:979, y:998},
                image: "res/" + pathFolder + "loadbar.png"
            }
        }
    },

    MainScene: {
        maingameBackground: {name: "mainbackground.jpg"},
        uiBorder: {pos: {x: 1625, y: 802}},
        resultWin: {pos: {x: 458, y: 404}},
        resultForward: {pos: {x: 558, y: 404}},
        resultLose: {pos: {x: 458, y: 404}},
    },

    UiScene: {
        buttonMore: {pos: {x: 1263, y: 622}},
        buttonStop: {pos: {x: 1263, y: 752}},
        labelDealerPoints: { pos: {x: 1189, y: 370}, font: {name: "font_points_desktop_horizontal"}},
        labelPlayerPoints: { pos: {x: 1189, y: 702}, font: {name: "font_points_desktop_horizontal"}},
        labelScoreWin: { pos: {x: 176, y: 487}, font: {name: "font_score_desktop_horizontal"}},
        labelScoreForward: { pos: {x: 176, y: 567}, font: {name: "font_score_desktop_horizontal"}},
        labelScoreLose: { pos: {x: 176, y: 646}, font: {name: "font_score_desktop_horizontal"}},
    },

    Cards: {
        GCardSizeX: 158,
        GCardSizeY: 250,
        GShirtsOffsetX: 1,
        GNewRoundEnd: {pos: {x: 1288, y: 295}},
        GCardOffsetX: 126,
        GCardSlide: 20,
        GDealerStart: {pos: {x: 283, y: 295}},
        GPlayerStart: {pos: {x: 283, y: 617}},
    },

    Settings: {
        background: {pos: {x: 191, y: 129}},
        selectDeck: {pos: {x: 387, y: 85}},
        titleClassic: {pos: {x: 902, y: 517}},
        titlePinup: {pos: {x: 155, y: 517}},
        buttonOk: {pos: {x: 511, y: 659}},
        arrDeckInfo: [
            {x: 1016, y: 264},
            {x: 281,  y: 265}
        ]
    },

    AccountChangedWindow: {
        background: {pos: {x: 334, y: 127}},
        buttonOk: {pos: {x: 492, y: 581}},
        labelTitle: {
            font: {
                fontFamily: "Arial",
                fontSize: 40,
                fill: 0xffffff,
                align: "centre"
            }
        }
    },

    Help: {
        background: {pos: {x: 191, y: 129}},
        backgroundTitle: {pos: {x: 506, y: 40}},
        buttonOk: {pos: {x: 511, y: 659}},
        labelTitle: {
            pos: {x: 544, y: 91},
            font: {
                fontFamily: "Arial",
                fontSize: 32,
                fill: 0xffffff,
                align: "left"
            }
        },
        labelInfo: {
            pos: {x: 44, y: 141},
            font: {
                fontFamily: "Arial",
                fontSize: 16,
                fill: 0xffffff,
                align: "left"
            }
        },
        translateList: {
            name: {
                rus:'Игра «21»',
                eng:'Game «21»',
            },
            info: {
                rus:'Постарайтесь угадать, когда сумма карт будет равна 21!\n' +
                '\n' +
                'Как играть?\n' +
                '\n' +
                '    Сделайте ставку. Размер начальной ставки определяется до начала игры.\n' +
                '    Максимальная сумма ставки составляет ' + '#01' + ', минимальная - ' + '#02' + '.\n' +
                '    В начале игры сдаются две карты. Нажимая кнопку "Еще", берите по одной карте до тех пор, пока не приблизитесь к 21 очку\n' +
                '           (дополнительно можно взять не более трех карт). Считаете, что пора остановиться? Тогда кликайте по кнопке "Стоп".\n' +
                '    Если вы набрали 21 очко с помощью двух карт — вы побеждаете. В этом случае дилер не имеет права добирать.\n' +
                '    Если вы набрали 21 очко (или меньше, но количество больше, чем у дилера) — вы получаете выигрыш по ставке в соответствии с коэффициентом (x2).\n' +
                '    Если у дилера сумма очков меньше 17 — он обязан добрать ещё карты. Если сумма равна или больше 17 — остановиться.\n' +
                '    Если вы сыграли вничью, то ваша ставка возвращается в соответствии с коэффициентом (x0.9).\n' +
                '\n' +
                'Пять картинок приравнивается к 21 очку.\n' +
                '\n' +
                'Если у вас больше 21 очка, то вы перебрали и проигрываете.\n' +
                '\n' +
                'Исключением является случай, когда у вас на руках два туза (золотое очко), которое считается равным 21.\n' +
                '\n' +
                'Игра автоматически завершается Ничьей при счете 20-20.\n' +
                '\n' +
                'Максимальное количество карт на руках - 5.\n' +
                '\n' +
                'Старшинство карт: 6, 7, 8, 9, 10, J, Q, K, A\n' +
                '\n' +
                'Стоимость карт в соответствии со старшинством: 6, 7, 8, 9, 10, 2, 3, 4, 11',

                eng:'Try to guess when the total value of cards gets to 21!\n' +
                '\n' +
                'How to play\n' +
                '\n' +
                '    Place a bet. The initial bet is determined before the start of a game.\n' +
                '    The maximum bet is ' + '#01' + ', the minimum bet is ' + '#02' + '.\n' +
                '    At the start of a game, the player (you) receive two cards and the dealer receive one card. \n' +
                '       You then take one card at a time by clicking "More" until the total value of the hand is close to 21 \n' +
                '       (you can take up to 3 additional cards).When you think it\'s time to stop, click "Stop".\n' +
                '    If you score 21 points with the first two cards, you win. In this case the dealer cannot take additional cards.\n' +
                '    If you score 21 points (or less than 21 but more than the dealer), your bet will be paid out at odds of x2.\n' +
                '    If the dealer scores less than 17 points, they must take additional cards. If the dealer scores 17 or more points, they must stand.\n' +
                '    If there is a draw ("push"), your bet will be paid out at odds of x0.9.\n' +
                '\n' +
                'Five cards with images equates to 21 points.\n' +
                '\n' +
                'If you score more than 21 points, you go bust and lose.\n' +
                '\n' +
                'An exception to this rule is when you hold two Aces ("Golden Point"), which scores you 21.\n' +
                '\n' +
                'If score 20-20 than game ends in a draw.\n' +
                '\n' +
                'The maximum number of cards on hand is 5.\n' +
                '\n' +
                'Cards ranking: 6, 7, 8, 9, 10, J, Q, K, A\n' +
                '\n' +
                'Value of cards according to their rank: 6, 7, 8, 9, 10, 2, 3, 4, 11\n'
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./cfg/desktop_horizontal/game.es6
// module id = 37
// module chunks = 0